import {createSlice} from '@reduxjs/toolkit'

export const idleTimeoutSlice = createSlice({
  name: 'idleTimeout',
  initialState: {
    isTimeout: false
  },
  reducers: {
    setIsTimeout: (state, action) => {
      state.isTimeout = action.payload
    }
  }
})

export const {setIsTimeout} = idleTimeoutSlice.actions

export default idleTimeoutSlice.reducer
